<template>
  <b-modal id="question"
           size="lg"
           :ok-only="true"
           :lazy="true"
           class="modal-box"
           hide-header>
    <iframe :src="link"
            width = "100"
            frameborder="0"
            scrolling="no"
            marginheight="0" marginwidth="0" >
    </iframe>
  </b-modal>
</template>

<script>
  export default {
    props: {
      link: {
        type: String
      }
    },
    data () {
      return {
        links: this.$store.state.links
      }
    }
  }
</script>

<style scoped>
  iframe {
    display: block;
    width: 100%;
    height: 500px;
    border: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/Mquestion.vue